import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Company-scoped settings (org details + saved destinations) were folded
 * into the user-profile Settings page (`/settings`), so there's a single
 * settings destination. This route now just redirects there; kept so any
 * existing `/organization` links still resolve.
 */
export function OrganizationPage(): React.ReactElement {
    return <Navigate to="/settings" replace />;
}
